import {Swiper, FreeMode, Thumbs} from 'swiper'
import { elementsToMaxHeight } from '../helpers/css-formating-helpers'

//-- Gallery Slider ---

export function initGalleries(galleries) {
  if (galleries.length) {

    galleries.each((i, el) => {

      let sliderC = $(el)
      let curSlide = sliderC.find('.js-current-slide')
      let nextB = sliderC.find('.js-next-slide')
      let prevB = sliderC.find('.js-prev-slide')
      let bigSlider = sliderC.find('.js-gallery-big')
      let thumbsSlider = sliderC.find('.js-gallery-thumbs')

      let thumbsSwiper = new Swiper(thumbsSlider[0], {
        modules: [FreeMode,Thumbs],
        spaceBetween: 8,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        // thumbs: {
        //   swiper: swiper,
        // },
      });
      let swiper = new Swiper(bigSlider[0], {
        modules: [FreeMode,Thumbs],
        spaceBetween: 10,
        thumbs: {
          swiper: thumbsSwiper,
        },
      });

      // navigation buttons
      nextB.click(() => swiper.slideNext())
      prevB.click(() => swiper.slidePrev())

      // slide change event
      swiper.on('slideChange', (slider) => {
        curSlide.text(slider.realIndex + 1)
      });

    })

  }

}

initGalleries($('.js-gallery-block'))
